(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage1', []);
})();
